module.exports = __webpack_public_path__ + "static/media/tick.4c3cf6de.svg";